export const formatDecimal = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const number = typeof value === 'number' ? value : Number(value.replace(',', '.'));

  if (!Number.isFinite(number)) {
    return '';
  }

  return number.toString().replace('.', ',');
};
